module.exports = __webpack_public_path__ + "static/ribbon-back-dc539ee75bdcc0e015a8d06e058ae79d.png";